import React, { useCallback, useState } from 'react';
import { Wrapper, Iframe, CloseButton } from './InAppWidget.styled';

export type InAppWidgetProps = {
	onClose: () => void;
	url: string;
	language: string;
	width: number;
	height: number;
};

const InAppWidget = ({ onClose, url, language, width, height }: InAppWidgetProps) => {
	const [show, setShow] = useState(false);

	const onLoad = useCallback(() => {
		setShow(true);
	}, []);

	return (
		<Wrapper show={show} width={width} height={height}>
			<Iframe allow="fullscreen" onLoad={onLoad} src={url.replace('{lang}', language)} />
			<CloseButton variant="iconButton" startIcon="close-medium-24" size="sm" onClick={onClose} />
		</Wrapper>
	);
};

export default InAppWidget;
